import Solr from '../services/Solr';
import utils from '../utils';
import config from './internetConfig';

const solrConfigs = {
	en: {
		// web results config
		web: {
			advanced: true,
			solrPath: 'internet/browse2',
			highlight: true,
			faceted: true, // whether to use extended fields (audience, topic)
			facets: [
				"topic_ss",
				"audience_ss",
	  			],
			fields: {
				type: 'type',
				jsonld: 'json_ld',
				date: 'dc_date3',
				language: 'lang',
				score: 'score',
				related: 'related_content_urls_s',
			},
			query: {
				df: 'strippedContent,title',
				'hl.fl': 'strippedContent,description',
				'hl.snippets': 2,
				affiliate: 'cdc-main',
			},
		},

		typeahead: {
			advanced: false,
			solrPath: 'internet_autocomplete/autocomplete',
			highlight: false,
			fields: {
				title: 'suggest_term',
			},
			query: {},
			queryFilter: (query, queryParts) => {
				// Typeahead terms query is unique
				// Entirely rebuild query here
				return {
					q: query.q,
					wt: 'json',
					rows: config.typeahead.max,
					fl: 'autocomplete_search_term',
				};
			},
			resultsFilter: (results, response) => {
				let terms = [];
				let docs =
					(response && response.data && response.data.response && response.data.response.docs) || [];
				if (Array.isArray(docs)) {
					docs.forEach((doc) => {
						let term = utils.cleanString(doc.autocomplete_search_term);
						if (term.match(/^[A-Z\s]+$/)) {
							term = term.toLowerCase();
						}

						terms.push(term);
					});
				}
				return terms;
			},
		},

		// web, best best config
		webBB: {
			bestBets: true,
			advanced: true,
			solrPath: 'internet/best-bets',
			highlight: true,
			fields: {
				type: 'type',
				jsonld: 'json_ld',
				date: 'dc_date3',
				language: 'lang',
				score: 'score',
				related: 'related_content_urls_s',
			},
			query: {
				rows: config.bestBets.limit,
				fl: ['id', 'title', 'url', 'description', 'type', 'json_ld'],
				df: 'strippedContent,title',
				'hl.fl': 'strippedContent,description',
				'hl.snippets': 2,
				fq: [
					'title:[*%20TO%20*]',
				],
				affiliate: 'cdc-main',
			},
			// Add 'bb' = true to each BestBest result
			resultFilter: function (result) {
				result.bb = true;
				return result;
			},
		},

		// video config
		video: {
			advanced: true,
			siteLimit: false,
			solrPath: 'internet_video/browse2',
			highlight: true,
			fields: {
				id: 'videoid',
				title: 'Title',
				description: 'Description',
				thumbnail: 'ThumbnailUrl',
				videoid: 'videoid',
				duration: 'Duration',
				url: 'WatchURL',
				lowres: 'LowResolutionLink',
				date: 'PublishDate',
			},
			query: {
				fl: [],
				'hl.fl': 'Description',
			},
		},

		// journals config
		journal: {
			advanced: true,
			solrPath: 'internet/browse2-journal',
			highlight: true,
			fields: {
				date: 'dc_date',
			},
			query: {
				'hl.fl': 'description',
			},
		},

		// podcast confg
		podcast: {
			advanced: true,
			siteLimit: false,
			solrPath: 'internet_podcast/browse2',
			highlight: true,
			fields: {
				id: 'PodcastId',
				title: 'PodcastTitle',
				series: 'PodcastSeriesTitle',
				seriesId: 'PodcastSeriesId',
				description: 'PodcastDescription',
				date: 'PodcastPublishDate',
				duration: 'PodcastDuration',
				audio: 'PodcastAudioUrl',
				size: 'PodcastAudioSize',
				transcript: 'PodcastTranscriptUrl',
			},
			query: {
				fl: [
					'PodcastId',
					'PodcastTitle',
					'PodcastSeriesTitle',
					'PodcastSeriesId',
					'PodcastDescription',
					'PodcastPublishDate',
					'PodcastDuration',
					'PodcastAudioUrl',
					'PodcastAudioSize',
				],
				'hl.fl': 'PodcastDescription',
			},
		},
	},
	es: {
		web: {
			advanced: true,
			solrPath: 'internet_es/browse2',
			highlight: true,
			fields: {
				type: 'type',
				date: 'dc_date3',
			},
			query: {
				fl: ['id', 'title', 'url', 'description', 'strippedContent', 'type', 'dc_date3'],
				'hl.fl': 'strippedContent,description',
				affiliate: 'cdc-main',
			},
		},
	},
};

// Allow for SOLR instance override in local config
// This was handy in testing new endpoints on test
for (let lang in solrConfigs) {
	for (let type in solrConfigs[lang]) {
		if (config.solr && config.solr[type] && 'object' === typeof config.solr[type]) {
			solrConfigs[lang][type] = config.solr[type];
		}
	}
}

// return service providers for each Solr instance
export default {
	en: {
		web: new Solr(solrConfigs.en.web, config),
		webnlp: new Solr(solrConfigs.en.webnlp, config),
		typeahead: new Solr(solrConfigs.en.typeahead, config),
		webBB: new Solr(solrConfigs.en.webBB, config),
		video: new Solr(solrConfigs.en.video, config),
		journal: new Solr(solrConfigs.en.journal, config),
		podcast: new Solr(solrConfigs.en.podcast, config),
	},
	es: {
		web: new Solr(solrConfigs.es.web, config),
	},
};
